import React from 'react';
import PropTypes from 'prop-types';

const LabelWithActionLink = (props) => {
  const { label, actionFunc, actionName  } = props;

  return (
    <>
      <span>{ label }</span>
      <span className="action-link" onClick={ actionFunc }>
        { actionName } <i className="zolaicon zolaicon-round-arrow-right"/>
      </span>
    </>
  )
};

LabelWithActionLink.propTypes = {
  label: PropTypes.string,
  actionFunc: PropTypes.func,
  actionName: PropTypes.string,
};

export default LabelWithActionLink;



// WEBPACK FOOTER //
// ./src/components/manage/common/EventForm/LabelWithActionLink.jsx